'use strict';

exports.__esModule = true;
var ADD_AJAX = exports.ADD_AJAX = 'ADD_AJAX';
var CANCEL_AJAX = exports.CANCEL_AJAX = 'CANCEL_AJAX';
var REMOVE_AJAX = exports.REMOVE_AJAX = 'REMOVE_AJAX';
var REMOVE_AJAX_RANGE = exports.REMOVE_AJAX_RANGE = 'REMOVE_AJAX_RANGE';
var UPDATE_AJAX_PROGRESS = exports.UPDATE_AJAX_PROGRESS = 'UPDATE_AJAX_PROGRESS';


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/ajax/action-types.js
 ** module id = 35
 ** module chunks = 0
 **/